<template>
    <span class="vuetify-wrapper">
        <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn
                    v-on="on"
                    :disabled="disabled"
                    @click="toggle"
                    :loading="loading"
                    class="disable-self-assign-btn"
                    min-width="30"
                    small
                    :title="title"
                >
                    <v-icon v-if="isSelfAssignDisabled" small color="red">mdi-clipboard-account</v-icon>
                    <v-icon v-else small color="green">mdi-clipboard-account</v-icon>
                </v-btn>
            </template>
            <span>
                {{ title }}
                <div>Durch einen Klick wird die selbst-Zuweisung {{ isSelfAssignDisabled ? 'zugelassen.' : 'unterbunden.' }}.</div>
            </span>
        </v-tooltip>
    </span>
</template>

<script>

import axios from 'axios';
import { mapMutations } from 'vuex'

export default {
    name: 'ToggleSelfAssignBtn',
    components: { },
    props: {
        appointmentid: String,
        isSelfAssignDisabled: Boolean,
        disabled: {
            default: false,
            type: Boolean,
        },
    },
    data: function() {
        return {
            loading: false,
        };
    },
    computed: {
        title() {
            if (this.isSelfAssignDisabled) {
                return "Dieser Termin kann von Freiberuflern NICHT selbst-zugewiesen werden."
            }
            return "Dieser Termin kann von Freiberuflern selbst-zugewiesen werden."
        },
    },
    methods: {
        async toggle() {
            this.loading = true;
            try {
                const response = await axios.post(`/api/appointments/${this.appointmentid}/toggle_self_assign_status/${!this.isSelfAssignDisabled}`);
                if (response.data){
                    this.$emit("update", response.data);
                }
            }
            catch(error) {
                this.alertError();
                console.warn("! failed to toggle self assign flag", error)
            }
            finally {
                this.loading = false;
            }
        },
        ...mapMutations({
            alertError: 'alert/error',
        })
    }
};
</script>



<style scoped>
.bootstrap-button {
    /** Make it look the same as the bootstrap buttons */
    border-radius: 3px;
    border-color: #ccc;
    width: 34px !important;
    height: 30px !important;
    color: #333 !important;
}

.red--text {
    color: red !important;
}

.green--text {
    color: green !important;
}
</style>
